import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.127",
      d: "M10.847 4.43h-.48v-.48z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M8.07 1.992a.6.6 0 0 1 .527.527l.004.07v2.403l.003.091A1.2 1.2 0 0 0 9.708 6.19l.095.004h2.403l.07.004a.6.6 0 0 1 .527.527l.004.07v1.207L12.75 8a1.74 1.74 0 0 0-1.07.366V7.321H9.76l-.095-.005q-.022 0-.045-.002a2.33 2.33 0 0 1-2.14-2.147l-.002-.047-.003-.09-.001-.038V3.115H4.995l-.04.001a.677.677 0 0 0-.636.675v8.412l.001.04.02.126a.675.675 0 0 0 .655.51h4.42c.32.38.799.621 1.335.621H11v.25q0 .13.02.255H4.995l-.172-.008a1.8 1.8 0 0 1-.934-.371l-.131-.111a1.8 1.8 0 0 1-.563-1.206l-.003-.106V3.791c0-.402.135-.791.38-1.106l.112-.131A1.8 1.8 0 0 1 4.89 1.99l.105-.003H8z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      d: "M12.75 9.75v4m-2-2h4",
      style: {"stroke":"#fff","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }